export default "__VITE_ASSET__BcVh9zZB__"